/**
 * Admin per-user feature grants (sketch, scope_gen, enhance, convert, mcp),
 * spread into BackendAPI. Split out of api.ts (god-file ratchet, PRP-MCP-7).
 */
import type { AxiosInstance } from 'axios';

/** One per-user feature grant row (user_entitlements). expires_at null = no end date. */
export interface AdminFeatureGrant {
  feature: string;
  source?: string | null;
  granted_by?: string | null;
  expires_at: string | null;
  created_at?: string | null;
}

export const grantsApi = (api: AxiosInstance) => ({
  /** A user's per-user feature grants (the comp switch: sketch, scope_gen,
   *  enhance, convert, mcp). */
  adminListUserGrants: (userId: string) =>
    api.get(`/admin/users/${encodeURIComponent(userId)}/entitlements`) as Promise<{
      user_id: string;
      grants: AdminFeatureGrant[];
    }>,

  /** Grant a feature to one user; expiresDays null = no end date. */
  adminGrantUserFeature: (userId: string, feature: string, expiresDays: number | null = null) =>
    api.post(`/admin/users/${encodeURIComponent(userId)}/entitlements`, {
      feature,
      expires_days: expiresDays,
    }) as Promise<{ user_id: string; grants: AdminFeatureGrant[] }>,

  /** Revoke a feature grant from one user. */
  adminRevokeUserFeature: (userId: string, feature: string) =>
    api.delete(
      `/admin/users/${encodeURIComponent(userId)}/entitlements/${encodeURIComponent(feature)}`,
    ) as Promise<{ user_id: string; feature: string; revoked: boolean }>,
});
